function requireViteEnv(name: keyof ImportMetaEnv): string {
  const value = import.meta.env[name];
  if (value == null || String(value).trim() === "") {
    throw new Error(`${String(name)} is not set. Copy frontend/.env.example → .env`);
  }
  return String(value);
}

export const env = {
  apiUrl: requireViteEnv("VITE_API_URL"),
  tokenStorageKey: requireViteEnv("VITE_TOKEN_STORAGE_KEY"),
  onboardingDraftKey: requireViteEnv("VITE_ONBOARDING_DRAFT_KEY"),
  paths: {
    creatorConfig: requireViteEnv("VITE_API_PATH_CREATOR_CONFIG"),
    creatorOnboarding: requireViteEnv("VITE_API_PATH_CREATOR_ONBOARDING"),
    creatorSeries: requireViteEnv("VITE_API_PATH_CREATOR_SERIES"),
    creatorAccounts: requireViteEnv("VITE_API_PATH_CREATOR_ACCOUNTS"),
    creatorAccountsConnect: requireViteEnv("VITE_API_PATH_CREATOR_ACCOUNTS_CONNECT"),
    creatorEpisodes: requireViteEnv("VITE_API_PATH_CREATOR_EPISODES"),
    billingMe: requireViteEnv("VITE_API_PATH_BILLING_ME"),
    billingInitialize: requireViteEnv("VITE_API_PATH_BILLING_INITIALIZE"),
    billingVerify: requireViteEnv("VITE_API_PATH_BILLING_VERIFY"),
    authSignup: requireViteEnv("VITE_API_PATH_AUTH_SIGNUP"),
    authLogin: requireViteEnv("VITE_API_PATH_AUTH_LOGIN"),
    authLogout: requireViteEnv("VITE_API_PATH_AUTH_LOGOUT"),
    authMe: requireViteEnv("VITE_API_PATH_AUTH_ME"),
    authGoogle: requireViteEnv("VITE_API_PATH_AUTH_GOOGLE"),
    adminOverview: requireViteEnv("VITE_API_PATH_ADMIN_OVERVIEW"),
    adminUsers: requireViteEnv("VITE_API_PATH_ADMIN_USERS"),
    adminAccounts: requireViteEnv("VITE_API_PATH_ADMIN_ACCOUNTS"),
    adminPlatforms: requireViteEnv("VITE_API_PATH_ADMIN_PLATFORMS"),
    adminEpisodes: requireViteEnv("VITE_API_PATH_ADMIN_EPISODES"),
  },
  routes: {
    home: requireViteEnv("VITE_ROUTE_HOME"),
    onboarding: requireViteEnv("VITE_ROUTE_ONBOARDING"),
    dashboard: requireViteEnv("VITE_ROUTE_DASHBOARD"),
    admin: requireViteEnv("VITE_ROUTE_ADMIN"),
    login: requireViteEnv("VITE_ROUTE_LOGIN"),
    seriesDetail: requireViteEnv("VITE_ROUTE_SERIES_DETAIL"),
  },
  labels: {
    login: requireViteEnv("VITE_LABEL_LOGIN"),
    dashboard: requireViteEnv("VITE_LABEL_DASHBOARD"),
    getStarted: requireViteEnv("VITE_LABEL_GET_STARTED"),
    newSeries: requireViteEnv("VITE_LABEL_NEW_SERIES"),
  },
};

/** Build `/dashboard/series/:id` from the env template. */
export function seriesDetailPath(seriesId: string) {
  return env.routes.seriesDetail.replace(":seriesId", seriesId);
}

export function creatorSeriesPath(seriesId: string) {
  return `${env.paths.creatorSeries}/${seriesId}`;
}

export function creatorEpisodePath(episodeId: string) {
  return `${env.paths.creatorEpisodes}/${episodeId}`;
}

export function creatorEpisodeProcessPath(episodeId: string) {
  return `${env.paths.creatorEpisodes}/${episodeId}/process`;
}

export function creatorEpisodeApprovePath(episodeId: string) {
  return `${env.paths.creatorEpisodes}/${episodeId}/approve`;
}

export function creatorEpisodePublishPath(episodeId: string) {
  return `${env.paths.creatorEpisodes}/${episodeId}/publish`;
}

export function creatorEpisodeDownloadPath(episodeId: string) {
  return `${env.paths.creatorEpisodes}/${episodeId}/download`;
}

export function creatorOnboardingSuggestCategoriesPath() {
  return `${env.paths.creatorOnboarding}/suggest-categories`;
}

export function creatorOnboardingSuggestTopicsPath() {
  return `${env.paths.creatorOnboarding}/suggest-topics`;
}
